/**
 * Translates debt descriptions from backend (always in English) to the current language
 * @param description The debt description from backend
 * @param t Translation function
 * @returns Translated description
 */
export const translateDebtDescription = (description: string | undefined, t: (key: string) => string): string => {
  if (!description) return '-';

  // Pattern matching for sale-related debts
  const salePattern = /^Sale:\s*(.+)$/;
  const paymentPattern = /^Payment for Sale:\s*(.+?)\s*\((.+)\)$/;

  // Check if it's a sale debt
  const saleMatch = description.match(salePattern);
  if (saleMatch) {
    const saleNumber = saleMatch[1].trim();
    return `${t('debts.sale')}: ${saleNumber}`;
  }

  // Check if it's a payment for sale
  const paymentMatch = description.match(paymentPattern);
  if (paymentMatch) {
    const saleNumber = paymentMatch[1].trim();
    const paymentMethod = paymentMatch[2].trim();
    
    // Translate payment method
    let translatedMethod = paymentMethod;
    const methodMap: { [key: string]: string } = {
      'CASH': t('sales.cash'),
      'Cash': t('sales.cash'),
      'CARD': t('sales.card'),
      'Card': t('sales.card'),
      'BANK_TRANSFER': t('sales.bankTransfer'),
      'Bank Transfer': t('sales.bankTransfer'),
      'CHECK': t('sales.check'),
      'Check': t('sales.check'),
      'OTHER': t('sales.other'),
      'Other': t('sales.other'),
    };
    
    if (methodMap[paymentMethod]) {
      translatedMethod = methodMap[paymentMethod];
    }
    
    return `${t('debts.paymentForSale')}: ${saleNumber} (${translatedMethod})`;
  }

  // If no pattern matches, return the original description
  return description;
};

